import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import Head from './Header';
import Body from './Body';
import Foot from './Footer';
import { existFixedColumns } from '../Utils/table';

/**
Le tabelle possono essere incorporate in una superficie, come una scheda o una card.
Le tabelle su card o schede possono avere strumenti di navigazione e di manipolazione dei dati in alto e in basso.
Possono essere editabili a seconda del contesto.
 */
const Table = ({
  children, clickable, bordered, striped, hover, fixedLayout, className,
}) => {
  const fixed = useMemo(() => (
    fixedLayout !== undefined && fixedLayout !== null ? fixedLayout : existFixedColumns(children, Head.Column)
  ), [children, fixedLayout]);

  return (
    <table className={cns(
      'table',
      {
        'table--bordered': bordered,
        'table--striped': striped,
        'table--hover': hover,
        'table--clickable': clickable,
        'table--fixed': fixed,
      },
      className,
    )}
    >
      {children}
    </table>
  );
};

Table.propTypes = {
  /** Indica se mostrare i bordi */
  bordered: PropTypes.bool,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se mostrare il cursore di tipo pointer sull'hover della riga */
  clickable: PropTypes.bool,
  /** Indica se evidenziare la riga sull'hover della stessa */
  hover: PropTypes.bool,
  /** Indica se evidenziare le righe alternate con un colore diverso */
  striped: PropTypes.bool,
  /**
Indica se la tabella deve gestire la dimensione fissa delle colonne.

Di default è in grado di determinarlo analizzando i children (vedi prop `width` di `Table.Head.Column`).
  */
  fixedLayout: PropTypes.bool,
};

Table.defaultProps = {
  bordered: false,
  children: null,
  className: '',
  clickable: false,
  hover: false,
  striped: false,
  fixedLayout: undefined,
};

Table.Head = Head;
Table.Body = Body;
Table.Foot = Foot;

export default Table;
